import Register from './components/Register/Register';
import Login from './components/Login';
import Layout from './components/Layout';
import Account from './components/Account';
import Profile from './components/Profile/Profile';
import Admin from './components/Admin/Admin';
import Questions from './components/Admin/Questions';
import Missing from './components/Missing';
import Unauthorized from './components/Unauthorized';
import VerifyEmail from './components/VerifyEmail';
import RequestVerification from './components/RequestVerification';
import ResetPassword from './components/ResetPassword';
import ChangePassword from './components/ChangePassword';
import RequireAuth from './components/RequireAuth';
import PersistLogin from './components/PersistLogin';
import EditConstantSumQuestion from './components/Admin/EditConstantSumQuestion';
import EditMatrix from './components/Admin/EditMatrix';
import EditMultipleChoiceQuestion from './components/Admin/EditMultipleChoiceQuestion';
import EditNumericQuestion from './components/Admin/EditNumericQuestion';
import EditTextQuestion from './components/Admin/EditTextQuestion';
import Surveys from './components/Admin/Surveys';
import EditSurvey from './components/Admin/EditSurvey';
import EditSurveyQuestions from './components/Admin/EditSurveyQuestions';
import SurveyResults from './components/SurveyResults/SurveyResults';
import Users from './components/Admin/Users';
import Benchmarking from './components/Benchmarking/Benchmarking';
import PollCategories from './components/Admin/PollCategories';
import Survey from './components/Survey/Survey';
import Insights from './components/Insights/Insights';
import EditPollCategory from './components/Admin/EditPollCategory';

import { Routes, Route } from 'react-router-dom'; 

function App() {

	return (
		<Routes>
			<Route path="/" element={<Layout />}>

				{/* public routes */}

				<Route path="login" element={<Login />} />
				<Route path="register" element={<Register />} />
				<Route path="verification" element={<RequestVerification />} />
				<Route path="resetpassword" element={<ResetPassword />} />
				<Route path="changepassword/:requestId/:requestToken" element={<ChangePassword />} />
				<Route path="verify" element={<VerifyEmail />} />
				<Route path="verify/:requestId" element={<VerifyEmail />} />
				<Route path="verify/:requestId/:requestToken" element={<VerifyEmail />} />
				<Route path="unauthorized" element={<Unauthorized />} />

				<Route element={<PersistLogin />}>

					{/* logged-in user routes */}

					<Route element={<RequireAuth requireLogin={true} requireAdmin={false} />}>
						<Route path="/" element={<Benchmarking />} />
						<Route path="account" element={<Account />} />
						<Route path="profile" element={<Profile />} />
						<Route path="benchmarking" element={<Benchmarking />} />
						<Route path="benchmarking/:surveyId" element={<Survey />} />
						<Route path="insights" element={<Insights />} />
						<Route path="insights/:surveyId" element={<Survey />} />
						<Route path="insights/:surveyId/results" element={<SurveyResults />} />
					</Route>

					{/* Admin-only routes */}

					<Route element={<RequireAuth requireLogin={true} requireAdmin={true} />}>
						<Route path="admin" element={<Admin />} />
						<Route path="questions" element={<Questions />} />
						<Route path="textquestion/new" element={<EditTextQuestion />} />
						<Route path="textquestion/edit/:questionId" element={<EditTextQuestion />} />
						<Route path="numericquestion/new" element={<EditNumericQuestion />} />
						<Route path="numericquestion/edit/:questionId" element={<EditNumericQuestion />} />
						<Route path="multiplechoicequestion/new" element={<EditMultipleChoiceQuestion />} />
						<Route path="multiplechoicequestion/edit/:questionId" element={<EditMultipleChoiceQuestion />} />
						<Route path="matrix/new" element={<EditMatrix />} />
						<Route path="matrix/edit/:questionId" element={<EditMatrix />} />
						<Route path="constantsumquestion/new" element={<EditConstantSumQuestion />} />
						<Route path="constantsumquestion/edit/:questionId" element={<EditConstantSumQuestion />} />
						<Route path="surveys" element={<Surveys />} />
						<Route path="survey/new" element={<EditSurvey />} />
						<Route path="survey/edit/:surveyId" element={<EditSurvey />} />
						<Route path="survey/edit/:surveyId/questions" element={<EditSurveyQuestions />} />
						<Route path="users" element={<Users />} />
						<Route path="insightscategories" element={<PollCategories />} />
						<Route path="insightscategory/new" element={<EditPollCategory />} />
						<Route path="insightscategory/edit/:pollCategoryId" element={<EditPollCategory />} />
					</Route>

				</Route>

				<Route path="*" element={<Missing />} />
			</Route>
		</Routes>
	);
}

export default App;